<template>
  <div>
    <div class="modal_title">Интеграция SMSGate</div>

    <div class="modal_subtitle">Название интеграции</div>
    <v-text-field
      v-model="form.name"
      placeholder="Например: Основной SMSGate"
      outlined
      dense
      @input="emitData"
    />

    <div class="modal_subtitle">Токен пользователя SMSGate</div>
    <v-text-field
      v-model="form.access_token"
      placeholder="Вставьте токен из личного кабинета SMSGate"
      outlined
      dense
      @input="emitData"
    />
  </div>
</template>

<script>
export default {
  props: ['update', 'pre_data'],

  data() {
    return {
      form: {
        name: '',
        access_token: '',
      },
    };
  },

  mounted() {
    if (this.pre_data) {
      this.form = {
        name: this.pre_data.name || '',
        access_token: this.pre_data.access_token || '',
      };
    }

    this.emitData();
  },

  methods: {
    emitData() {
      this.update({
        name: this.form.name,
        access_token: this.form.access_token,
      });
    },
  },
};
</script>

<style scoped>
.modal_title {
  padding: 0 !important;
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  margin-bottom: 24px;
  text-align: center;
  line-height: 130%;
  color: #2b2d33;
}

.modal_subtitle {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  margin-bottom: 6px;
  text-align: left;
  color: #404247;
}
</style>
